import { render, staticRenderFns } from "./StudentsExternal.vue?vue&type=template&id=61f76706&"
import script from "./StudentsExternal.vue?vue&type=script&lang=js&"
export * from "./StudentsExternal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports